import axios from 'axios'
import Vue from 'vue'


export default class MotivateCloudApi {
  constructor(currentUser) {

    this.client = axios.create({
      baseURL: process.env.VUE_APP_CLOUD_API,
      timeout: 10000,
      headers: {
        currentUser: JSON.stringify(currentUser),
        secretToken: 'a52f0d605607d68f9e732b557da737b5'
      }
    });
  }

  getCloudApi() {
    return this.client
  }

}


